let inspectletScriptLoaded = false;
const inspectletIdentifyQueue = [];

export function initInspectlet(userIdOrParams) {
  if (typeof window === "undefined") return;

  window.__insp = window.__insp || [];

  // Push wid ONLY ONCE before any other commands
  if (!window.__insp._widSet) {
    window.__insp.push(["wid", 302250859]);  // Your Inspectlet ID here
    window.__insp._widSet = true;
  }

  if (!inspectletScriptLoaded) {
    (function () {
      const inspScript = document.createElement("script");
      inspScript.type = "text/javascript";
      inspScript.async = true;
      inspScript.id = "inspsync";
      inspScript.src =
        (document.location.protocol === "https:" ? "https:" : "http:") +
        "//cdn.inspectlet.com/inspectlet.js?wid=302250859&r=" +
        Math.floor(new Date().getTime() / 3600000);

      inspScript.onload = () => {
        inspectletScriptLoaded = true;
        inspectletIdentifyQueue.forEach((params) => {
          window.__insp.push(["identify", params]);
        });
        inspectletIdentifyQueue.length = 0;
      };

      const firstScript = document.getElementsByTagName("script")[0];
      firstScript.parentNode.insertBefore(inspScript, firstScript);
    })();
  }

  if (inspectletScriptLoaded) {
    window.__insp.push(["identify", userIdOrParams]);
  } else {
    inspectletIdentifyQueue.push(userIdOrParams);
  }
}
